import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList, useListKeys, useObject } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { auth, db, logout, firebase_update, firebase_update_device, firebase_get_device_log} from "./firebase";

import moment from "moment-timezone";

import Map from "./components/map";

import { CSVLink } from "react-csv";

import ReportIcon from './images/chart.svg';

import { useLocation } from 'react-router-dom';


import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { red } from "@mui/material/colors";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineController,
  BarController,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from 'chart.js';

import { Chart } from 'react-chartjs-2';

const { faker } = require('@faker-js/faker');

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineController,
  BarElement,
  BarController,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

function ChartData(props){

  //const r = '/device_logs/' + props.deviceId  + "/" + moment(props.date).format("yyyy") + "/" + (moment(props.date).format("MM")) + "/" + moment(props.date).format("DD") + "/";
  //console.log(r)

  //const [device_log_snapshot, loading_device_log, error_db] = useList(db.ref(r));
  
  const [device_log_snapshot, loading_device_log, error_db] = useList(db.ref(props.r)
    //.child(props.deviceId)
    //.child(moment(props.daterange[0].startDate).format("yyyy"))
    //.child(moment(props.daterange[0].startDate).format("MM"))
    .orderByKey()
    .startAt(props.startdate)
    .endAt(props.enddate));

  //console.log(props.startdate + ":" + props.startmonth + ":" + props.startyear);
  //console.log(props.enddate + ":" + props.endmonth + ":" + props.endyear);


  const [dateStamp, setDateStamp] = useState([]);
  const [labels, setLabels] = useState([]);
  const [deviceP1Log, setDeviceP1Log] = useState([]);
  const [deviceP2Log, setDeviceP2Log] = useState([]);
  const [deviceTempLog, setDeviceTempLog] = useState([]);
  const [deviceLevelLog, setDeviceLevelLog] = useState([]);
  const [deviceR1Log, setDeviceR1Log] = useState([]);
  const [deviceR2Log, setDeviceR2Log] = useState([]);
  const [deviceLevelTrendLog, setDeviceLevelTrendLog] = useState([]);
  const [deviceDataPlot, setDeviceDataPlot] = useState([]);

  const [deviceInfo, setDeviceInfo] = useState();

  const [plotLevel, setPlotLevel] = useState(props.deviceInfo.level.hardware_status=='installed');
  const [plotP1, setPlotP1] = useState(props.deviceInfo.pressure.p1.hardware_status=='installed');
  const [plotP2, setPlotP2] = useState(props.deviceInfo.pressure.p2.hardware_status=='installed');
  const [plotTemp, setPlotTemp] = useState(props.deviceInfo.temperature.t1.hardware_status=='installed');
  const [plotR1, setPlotR1] = useState(props.deviceInfo.relay.r1.hardware_status=='installed');
  const [plotR2, setPlotR2] = useState(props.deviceInfo.relay.r2.hardware_status=='installed');

  /*console.log("YEAR :: " + moment(props.daterange[0].startDate).format("yyyy"));
  console.log("MONTH :: " + moment(props.daterange[0].startDate).format("MM"));
  console.log("DAY START :: " + moment(props.daterange[0].startDate).format("DD"));
  console.log("DAY END :: " + moment(props.daterange[0].endDate).format("DD"));
  console.log("REF :: " + "device_logs/" + props.deviceId + "/" + moment(props.daterange[0].startDate).format("yyyy") + "/" + moment(props.daterange[0].startDate).format("MM"));*/

  useEffect(async () => {
      //console.log("DEVICE INFO PROPS ==> ")
      //console.log(props.deviceInfo)
      setDeviceInfo(props.deviceInfo);
      //setPlotLevel(props.deviceInfo.level.hardware_status=='installed')
      //setPlotTemp(props.deviceInfo.temperature.t1.hardware_status=='installed');
      //console.log("PLOT TEMP FROM CHARTDATA :: " + plotTemp)
      
     if(device_log_snapshot && !loading_device_log)
      {
        var data = [];
        var dateStamp = [];
        var labels = [];
        var p1 = [];
        var p2 = [];
        var t = [];
        var l = [];
        var tr = [];
        var r1 = [];
        var r2 = [];
        var index = 0;
        device_log_snapshot.map(log=>{
          //console.log("Day-Month-Year :: " + log.key + "-" + props.startmonth + "-" + props.startyear)
          log.forEach(item => {
            if(index < 1)
            {
              //console.log("INDEX :: " + index)
              //console.log(item.key.substring(0,2) + ":" + item.key.substring(2,4) + ":" + item.key.substring(4,6))
              dateStamp.push(props.startmonth + "/" + log.key + "/" + props.startyear);
              labels.push(item.key.substring(0,2) + ":" + item.key.substring(2,4) + ":" + item.key.substring(4,6));
              if(item.val().pressures.hasOwnProperty("p1"))
              {
                p1.push(parseFloat(item.val().pressures.p1.value));
              }
              if(item.val().pressures.hasOwnProperty("p2"))
              {
                p2.push(parseFloat(item.val().pressures.p2.value));
              }
              if(item.val().hasOwnProperty("temp"))
              {
                t.push(parseFloat(item.val().temp));
              }
              if(item.val().hasOwnProperty("weight"))
              {
                l.push(parseFloat(item.val().weight));
              }
              if(item.val().level.hasOwnProperty("trend"))
              {
                tr.push(parseFloat(item.val().level.trend));
              }
              if(item.val().relays.hasOwnProperty("r1"))
              {
                r1.push((item.val().relays.r1.value == 'true') ? 50 : 0)
              }
              if(item.val().relays.hasOwnProperty("r2"))
              {
                r2.push((item.val().relays.r2.value == 'true') ? 50 : 0)
              }
              index++;
            }
            else
            {
              //console.log("INDEX :: " + index)
              var now = moment(props.startmonth + "/" + log.key + "/" + props.startyear + " " + item.key.substring(0,2) + ":" + item.key.substring(2,4) + ":" + item.key.substring(4,6),"MM/DD/yyyy HH:mm:ss");
              var prev = moment(props.startmonth + "/" + log.key + "/" + props.startyear + " " + labels[index-1], "MM/DD/yyyy HH:mm:ss");
              //console.log(now.format("MM/DD/yyyy HH:mm:ss"));
              //console.log(prev.format("MM/DD/yyyy HH:mm:ss"))
              if(Math.abs(now.diff(prev, "seconds")) > 60)
              {
                dateStamp.push(props.startmonth + "/" + log.key + "/" + props.startyear);
                labels.push(item.key.substring(0,2) + ":" + item.key.substring(2,4) + ":" + item.key.substring(4,6));
                if(item.val().pressures.hasOwnProperty("p1"))
                {
                  p1.push(parseFloat(item.val().pressures.p1.value));
                }
                if(item.val().pressures.hasOwnProperty("p2"))
                {
                  p2.push(parseFloat(item.val().pressures.p2.value));
                }
                if(item.val().hasOwnProperty("temp"))
                {
                  t.push(parseFloat(item.val().temp));
                }
                if(item.val().hasOwnProperty("weight"))
                {
                  l.push(parseFloat(item.val().weight));
                }
                if(item.val().level.hasOwnProperty("trend"))
                {
                  tr.push(parseFloat(item.val().level.trend));
                }
                if(item.val().relays.hasOwnProperty("r1"))
                {
                  r1.push((item.val().relays.r1.value == 'true') ? 50 : 0)
                }
                if(item.val().relays.hasOwnProperty("r2"))
                {
                  r2.push((item.val().relays.r2.value == 'true') ? 50 : 0)
                }
                index++;
              }
            }
          })
        });
        setDateStamp(dateStamp);
        setLabels(labels);
        setDeviceP1Log(p1);
        setDeviceP2Log(p2);
        setDeviceTempLog(t);
        setDeviceLevelLog(l);
        setDeviceLevelTrendLog(tr);
        setDeviceR1Log(r1);
        setDeviceR2Log(r2);       
        reloadData(p1, p2, t, l, tr, r1, r2);
      } 
      else
      {
        updatePlot(props.deviceInfo);
      }
     
  }, [device_log_snapshot, loading_device_log, props.deviceInfo]);

  useEffect(() => {
    //console.log("HERE")
    updatePlot(props.deviceInfo)
  }, [plotP1, plotP2, plotTemp, plotLevel, plotR1, plotR2]);

  const computeLevelFillStartStop = (data, dateStamp) => {
    var filled_start_count = 0;
    var filled_stop_count = 0;
    var filled_start_date = [];
    var filled_start_time = [];
    var level_start = []; 
    var level_kg_start = [];
    var filled_stop_date = [];
    var filled_stop_time = [];
    var filled_start = true;
    var level_stop = [];
    var level_kg_stop = [];
    if(data)
    {
      // start filling
      for(var i=1;i<data.length;i++)
      {
        const trend = data[i] - data[i-1];
          if(filled_start)
          {
            if(trend >= 0)
            {
              filled_start_count++;
              //console.log("Start checking filling at :: " + labels[i] + " = " + filled_start_count);
            }
            else if(trend < 0) // reset fill 
            {
              filled_start_count = 0;
              //console.log("Reset checking at :: " + labels[i]);
            }

            if((trend > 3) && (filled_start_count == 0))
            {
              //console.log("Filling > 3% at :: " + labels[i-1])
              filled_start_date.push(dateStamp[i-1]);
              filled_start_time.push(labels[i-1]);
              level_start.push(data[i-1]);
              level_kg_start.push(parseFloat(data[i-1])*parseFloat(props.deviceInfo.level.full_tank)/100);
              filled_start_count = 0;
              filled_start = false;
            }
            else if(filled_start_count == 3)
            {
              //console.log("Filling after 3 consecutive up :: " + labels[i-3]);
              filled_start_date.push(dateStamp[i-3]);
              filled_start_time.push(labels[i-3]);
              level_start.push(data[i-3]);
              level_kg_start.push(parseFloat(data[i-3])*parseFloat(props.deviceInfo.level.full_tank)/100);
              filled_start_count = 0;
              filled_start = false;
            }
          }
          else
          {
            if(trend <= 0)
            {
              filled_stop_count++;
              //console.log("Start checking stop filling at :: " + labels[i] + " = " + filled_stop_count);
            }
            else if(trend > 0) // reset fill
            {
              filled_stop_count = 0;
              //console.log("Reset checking stop filling at :: " + labels[i]);
            }
            
            if((trend < -2) && (filled_stop_count == 0))
            {
              //console.log("Stop filling < 2% at :: " + labels[i-1])
              filled_stop_date.push(dateStamp[i-1]);
              filled_stop_time.push(labels[i-1]);
              level_stop.push(data[i-1]);
              level_kg_stop.push(parseFloat(data[i-1])*parseFloat(props.deviceInfo.level.full_tank)/100);
              filled_stop_count = 0;
              filled_start = true;
            }
            else if(filled_stop_count == 3)
            {
              //console.log("Stop filling after 3 consecutive down :: " + labels[i-3]);
              filled_stop_date.push(dateStamp[i-3]);
              filled_stop_time.push(labels[i-3]);
              level_stop.push(data[i-3]);
              level_kg_stop.push(parseFloat(data[i-3])*parseFloat(props.deviceInfo.level.full_tank)/100);
              filled_stop_count = 0;
              filled_start = true;
            }            
          }
      }
    }
    const csvData = [
      ["Start filling date", "Start filling time", "%", "kg", "Stop filling date", "Stop filling time", "%", "kg", "Diff"],
    ]
    for(var i=0; i<filled_start_date.length; i++)
    {
     csvData.push([filled_start_date[i], filled_start_time[i], level_start[i], level_kg_start[i], filled_stop_date[i], filled_stop_time[i], level_stop[i], level_kg_stop[i], parseFloat((parseFloat(level_kg_stop[i]) - parseFloat(level_kg_start[i])).toFixed(2))]);
    }
    //console.log(csvData);
    return csvData;
  }

  const computeLevelFill = (data) => {
    var num_filled = 0;
    var filled_count = 0;
    var count_reset = 0;
    if(data)
    {
      for(var i=1;i<data.length;i++)
      {
        const trend = data[i] - data[i-1]
        if(trend > 0)
        {
          filled_count++;
        }
        else if(trend < 0) // reset fill
        {
          filled_count = 0;
          count_reset = 0;
        }
        if((filled_count == 3) && (count_reset == 0))
        {
          num_filled++;
          count_reset = 1;
        }
      }
    }
    //console.log("Fill = " + num_filled);
    return num_filled;
  }

  const reloadData = (p1, p2, t, l, tr, r1, r2) => {
    var data = [];
    if(props.deviceInfo.level.hardware_status=='installed')
    {
      data.push(
        {
          type: 'line',
          label: 'Level (%) with ' + computeLevelFill(l) + ' fill(s)',
          data: l,
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
          yAxisID: 'y',
        });
    }
    if(props.deviceInfo.temperature.t1.hardware_status=='installed')
    {
      data.push(
        {
          type: 'line',
          label: 'Temperature',
          data: t,
          borderColor: 'rgb(53, 233, 235)',
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
          yAxisID: 'y1',
        },
      )
    }
    if(props.deviceInfo.pressure.p1.hardware_status=='installed')
    {
      data.push(
        {
          type: 'line',
          label: 'Run A',
          data: p1,
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
          yAxisID: 'y',
        },
      )
    }
    if(props.deviceInfo.pressure.p2.hardware_status=='installed')
    {
      data.push(
        {
          type: 'line',
          label: 'Run B',
          data: p2,
          borderColor: 'rgb(53, 162, 235)',
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
          yAxisID: 'y',
        },
      )
    }
    if(props.deviceInfo.relay.r1.hardware_status=='installed')
    {
      data.push(
        {
          type: 'bar',
          label: 'Heater 1',
          data: r1,
          borderColor: '#4caf50',
          backgroundColor: '#4caf50',
          yAxisID: 'y2',
        },
      )
    }
    if(props.deviceInfo.relay.r2.hardware_status=='installed')
    {
      data.push(
        {
          type: 'bar',
          label: 'Heater 2',
          data: r2,
          borderColor: '#7e57c2',
          backgroundColor: '#7e57c2',
          yAxisID: 'y2',
        }
      )
    }
    //console.log(data)
    setDeviceDataPlot(data);  
  }

  const updatePlot = (deviceInfo) =>{
    //console.log("UPDATE LOG ===>")
    //console.log(deviceInfo)
    var data = [];
    if((deviceInfo.level.hardware_status=='installed') && plotLevel)
    {
      data.push(
        {
          type: 'line',
          label: 'Level (%) with ' + computeLevelFill(deviceLevelLog) + ' fill(s)',
          data: deviceLevelLog,
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
          yAxisID: 'y',
        });
    }
    if((deviceInfo.temperature.t1.hardware_status=='installed') && plotTemp)
    {
      data.push(
        {
          type: 'line',
          label: 'Temperature',
          data: deviceTempLog,
          borderColor: 'rgb(53, 233, 235)',
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
          yAxisID: 'y1',
        },
      )
    }
    if((deviceInfo.pressure.p1.hardware_status=='installed') && plotP1)
    {
      data.push(
        {
          type: 'line',
          label: 'Run A',
          data: deviceP1Log,
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
          yAxisID: 'y',
        },
      )
    }
    if((deviceInfo.pressure.p2.hardware_status=='installed') && plotP2)
    {
      data.push(
        {
          type: 'line',
          label: 'Run B',
          data: deviceP2Log,
          borderColor: 'rgb(53, 162, 235)',
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
          yAxisID: 'y',
        },
      )
    }
    if((deviceInfo.relay.r1.hardware_status=='installed') && plotR1)
    {
      data.push(
        {
          type: 'bar',
          label: 'Heater 1',
          data: deviceR1Log,
          borderColor: '#4caf50',
          backgroundColor: '#4caf50',
          yAxisID: 'y2',
        },
      )
    }
    if((deviceInfo.relay.r2.hardware_status=='installed') && plotR2)
    {
      data.push(
        {
          type: 'bar',
          label: 'Heater 2',
          data: deviceR2Log,
          borderColor: '#7e57c2',
          backgroundColor: '#7e57c2',
          yAxisID: 'y2',
        }
      )
    }
    setDeviceDataPlot(data);  
  }

  if (loading_device_log)
  {
    return (<Paper style={{height: '270px'}} component={Stack} direction="column" justifyContent="center">
            <Typography variant="caption" style={{textAlign: "center", alignItems: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Loading device log...
              </Typography>
            </Paper>);
  }


const computeTrendFill = (data) => {
  var number_of_fill = 0;
  var trend_plus_count = 0;
  data.map(trend => {
    if(trend > 0)
    {
      trend_plus_count++;
    }
    if((trend_plus_count > 2) && (trend < 0)) // reset fill
    {
      number_of_fill++;
      trend_plus_count = 0;
    }
  });
  console.log("Fill = " + number_of_fill);
}



const handleChangePlotLevel = (event) => {
  setPlotLevel(event.target.checked);
}

const handleChangePlotP1 = (event) => {
  setPlotP1(event.target.checked);
}

const handleChangePlotP2 = (event) => {
  setPlotP2(event.target.checked);
}

const handleChangePlotTemp = (event) => {
  setPlotTemp(event.target.checked);
}

const handleChangePlotR1 = (event) => {
  setPlotR1(event.target.checked);
}

const handleChangePlotR2 = (event) => {
  setPlotR2(event.target.checked);
}

const displayChart = () => {
  if(props.type === 'tank')
  {
    return <Box display="flex" justifyContent="center" sx={{ flexDirection: 'column'}} >
            <Stack>
            <Chart 
              height="100px"
              options = {{
                maintainAspectRatio: true,
                responsive: true,
                plugins: {
                  legend: {
                    position: 'top',
                  },
                  title: {
                    display: true,
                    text: 'LPG Status ' + (moment(props.startyear + props.startmonth + props.startdate).isSame(moment(props.endyear + props.endmonth + props.enddate), 'day') ? "@" + moment(props.startyear + props.startmonth + props.startdate).format("MMM DD, yyyy"): "from " + (moment(props.startyear + props.startmonth + props.startdate).format("MMM DD, yyyy") + " to " + moment(props.endyear + props.endmonth + props.enddate).format("MMM DD, yyyy"))),
                  },
                },
                scales: {
                  y: {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    text: "Pressure (psi)",
                  },                  
                }
              }}
              data={{
              labels,
              datasets: deviceDataPlot,
            }} />
            <FormGroup sx={{alignItems: 'center'}}>
              <Stack direction="row">
              {(props.deviceInfo.level.hardware_status=='installed') && <FormControlLabel control={<Checkbox defaultChecked={props.deviceInfo.level.hardware_status=='installed'} size="small" checked={plotLevel} onChange={handleChangePlotLevel} />} label="Level" disabled={props.deviceInfo.level.hardware_status=='not_installed'} />}
              {(props.deviceInfo.temperature.t1.hardware_status=='installed') && <FormControlLabel control={<Checkbox defaultChecked={props.deviceInfo.temperature.t1.hardware_status=='installed'} size="small" checked={plotTemp} onChange={handleChangePlotTemp} />} label="Temperature" disabled={props.deviceInfo.temperature.t1.hardware_status=='not_installed'} />}
              </Stack>
            </FormGroup>
            </Stack>
            </Box>
            
  }
  else
  {
  return <Box display="flex" justifyContent="center" sx={{ flexDirection: 'column'}}>
            <Chart 
                options = {{
                  responsive: true,
                  plugins: {
                    legend: {
                      position: 'top',
                    },
                    title: {
                      display: true,
                      text: 'LPG Status ' + (moment(props.startyear + props.startmonth + props.startdate).isSame(moment(props.endyear + props.endmonth + props.enddate), 'day') ? "@" + moment(props.startyear + props.startmonth + props.startdate).format("MMM DD, yyyy"): "from " + (moment(props.startyear + props.startmonth + props.startdate).format("MMM DD, yyyy") + " to " + moment(props.endyear + props.endmonth + props.enddate).format("MMM DD, yyyy"))),
                    },
                  },
                  scales: {
                    y: {
                      type: 'linear',
                      display: true,
                      position: 'left',
                      text: "Pressure (psi)",
                    },
                    y1: {
                      type: 'linear',
                      display: true,
                      position: 'right',
                      text: 'Temperature (C)',
                      // grid line settings
                      grid: {
                        drawOnChartArea: false, // only want the grid lines for one axis to show up
                      },
                    },
                    y2: {
                      type: 'linear',
                      display: true,
                      position: 'right',
                      // grid line settings
                      grid: {
                        drawOnChartArea: false, // only want the grid lines for one axis to show up
                      },
                    },
                  }
                }}
              data={{
                labels,
                datasets: deviceDataPlot,
            }} />
            <FormGroup sx={{alignItems: 'center'}}>
              <Stack direction="row">
                {(props.deviceInfo.pressure.p1.hardware_status=='installed') && <FormControlLabel control={<Checkbox defaultChecked={props.deviceInfo.pressure.p1.hardware_status=='installed'} size="small" checked={plotP1} onChange={handleChangePlotP1} disabled={props.deviceInfo.pressure.p1.hardware_status=='not_installed'} />} label="Run A" />}
                {(props.deviceInfo.pressure.p1.hardware_status=='installed') && <FormControlLabel control={<Checkbox defaultChecked={props.deviceInfo.pressure.p2.hardware_status=='installed'} size="small" checked={plotP2} onChange={handleChangePlotP2} disabled={props.deviceInfo.pressure.p2.hardware_status=='not_installed'} />} label="Run B" />}
                {(props.deviceInfo.temperature.t1.hardware_status=='installed') && <FormControlLabel control={<Checkbox defaultChecked={props.deviceInfo.temperature.t1.hardware_status=='installed'} size="small" checked={plotTemp} onChange={handleChangePlotTemp} disabled={props.deviceInfo.temperature.t1.hardware_status=='not_installed'} />} label="Temperature" />}
                {(props.deviceInfo.relay.r1.hardware_status=='installed') && <FormControlLabel control={<Checkbox defaultChecked={props.deviceInfo.relay.r1.hardware_status=='installed'} size="small" checked={plotR1} onChange={handleChangePlotR1} disabled={props.deviceInfo.relay.r1.hardware_status=='not_installed'} />} label="Heater 1" />}
                {(props.deviceInfo.relay.r2.hardware_status=='installed') && <FormControlLabel control={<Checkbox defaultChecked={props.deviceInfo.relay.r2.hardware_status=='installed'} size="small" checked={plotR2} onChange={handleChangePlotR2} disabled={props.deviceInfo.relay.r2.hardware_status=='not_installed'} />} label="Heater 2" />}
              </Stack>
            </FormGroup>
          </Box>
  }
}

const displayChartTool = () => {
  return <Stack direction="row" sx={{bgcolor: '#f2f2f2'}}>
            <CSVLink 
              data={computeLevelFillStartStop(deviceLevelLog, dateStamp)}
              target="_blank"
              filename={"FillingReport.csv"}
            >
              <IconButton><img
                src={ReportIcon}
                alt={"Generate gas filling report"}
                loading="lazy"
                style={
                  {
                    width: 45,
                    height: 45,
                  }
                }
              /></IconButton>  
            </CSVLink>
          </Stack>
}

  return (<div className="container">
            <Stack>
            {displayChart()}
            {props.type == 'tank' && displayChartTool()}
            </Stack>
        </div>);
}

export default ChartData;
